export default __webpack_public_path__ + "static/media/worldwide.b0f120ff.png";